import React from 'react';
import CommonBanner from "../component/Common/CommonBanner";
import { ImageConstants } from "../assets/img/ImageConstants";
import StaticSEOTags from '../component/DynamicSEO/StaticSEOTags';
import Img from "../assets/img/imagination/tourall.jpg";
const InternationalTourPackages = () => {
  return (
    <>
      <StaticSEOTags
        fallbackTitle="International Tour Packages - Polifly Travels"
        fallbackDescription="Explore the world with tailored international tour packages by Polifly Travels. Budget-friendly, well-organized trips for families, couples, groups, and solo travelers."
        fallbackKeywords="international tour packages, Dubai tour, Turkey tour, Malaysia Thailand package, Bali tour, Europe UK tour, USA Canada tour, Polifly Travels"
        fallbackOgTitle="International Tour Packages - Polifly Travels"
        fallbackOgDescription="Expertly crafted international tour packages that fit your budget, preferences, and travel goals."
        fallbackCanonicalUrl="https://poliflytravels.com/international-tour-packages/"
      />

      <CommonBanner
        heading="International Tour Packages"
        img={ImageConstants.visabanner}
        pagination="International Tour Packages"
      />

      <section className="international-tour-packages-area pt-5 pb-5 mt-5 mb-5">
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <div className="content-wrapper visa-content">
                <h2 className="mb-4">Polify Travels – International Tour Packages Tailored for You</h2>
                <p className="mb-5">
                  Dreaming of exploring the world without the stress of planning every detail? Polify Travels offers expertly crafted international tour packages that fit your budget, preferences, and travel goals.
                </p>

                <div className="mb-5">
                  <h3 className="mb-3">Explore the World with Ease</h3>
                  <p>
                    From relaxing getaways to adventurous expeditions, our affordable and well-organized packages cater to every kind of traveler — be it families, honeymooners, groups, or solo explorers.
                  </p>
                </div>

               


              
              </div>
            </div>

            <div className="col-lg-6">
            <img src={Img} alt="img" />
            </div>


          </div>
          <div className='row mt-5 pb-5'>
            <div className='col-lg-6'>
            <div className="mb-5">
                  <h3 className="mb-3">Popular Destinations</h3>
                  <ul className="benefits-list">
                    <li>Dubai – Luxury experiences, desert safaris, and world-class shopping</li>
                    <li>Turkey – Rich culture, history, and breathtaking landscapes</li>
                    <li>Malaysia & Thailand – Beaches, nightlife, and vibrant local scenes</li>
                    <li>Bali & Indonesia – Serenity, spas, and tropical beauty</li>
                    <li>Saudi Arabia – Spiritual and religious tours</li>
                    <li>Europe & UK – Historic cities, architecture, and scenic escapes</li>
                    <li>USA & Canada – Iconic landmarks, entertainment, and natural wonders</li>
                  </ul>
                </div> 
                </div>
            <div className='col-lg-6'>  
            <div className="mb-5">
                  <h3 className="mb-3">What’s Included in Our Packages?</h3>
                  <ul className="benefits-list">
                    <li>Round-trip airfare</li>
                    <li>Comfortable hotel stays</li>
                    <li>Daily breakfast</li>
                    <li>Guided city tours</li>
                    <li>Airport transfers</li>
                    <li>Visa assistance (if needed)</li>
                  </ul>
                </div>
              
            </div>
          </div>





          <div className='row'>
            <div className='col-lg-6'>
        
                <div className="mb-5">
                  <h3 className="mb-3">Why Travel with Polify Travels?</h3>
                  <ul className="benefits-list">
                    <li>Experienced team in international travel planning</li>
                    <li>Flexible itineraries tailored to your interests</li>
                    <li>No hidden charges – fully transparent pricing</li>
                    <li>Ongoing support before and during your journey</li>
                  </ul>
                </div> </div>
            <div className='col-lg-6'>  
          
                <div className="get-in-touch mb-5">
                  <h3 className="mb-3">Let’s Plan Your Perfect Trip</h3>
                  <p>
                    Just share your destination or travel ideas, and we’ll create the perfect international package for you. With Polify Travels, your journey is in safe hands — all you need to do is pack!
                  </p>
                  <p className="mt-3"><strong>Polify Travels – Discover the World with Confidence.</strong></p>
               
                </div>
            </div>
          </div>
         
        </div>
      </section>
    </>
  );
};

export default InternationalTourPackages;